var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 481,
    viewBox: "0 0 512 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.799 367.16C466.221 372.1 462.366 376.345 457.458 376.345H53.8258C48.9306 376.345 45.0798 372.12 45.4836 367.189L74.4091 14.154C74.7691 9.76864 78.3961 6.39395 82.7535 6.39395H427.328C431.672 6.39395 435.295 9.75171 435.667 14.1244L465.799 367.16Z",
    fill: "#1DCF65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.745 469.588C498.249 475.749 493.436 481.032 487.319 481.032H24.4643C18.3594 481.032 13.5501 475.776 14.0335 469.624L47.262 46.735C47.6952 41.2352 52.2346 37 57.6928 37H452.705C458.15 37 462.685 41.2183 463.134 46.701L497.745 469.588Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.255 336.606C196.01 336.606 147 277.149 147 204.068C147 200.262 150.053 197.174 153.823 197.174C157.592 197.174 160.645 200.259 160.645 204.068C160.645 269.548 203.536 322.819 256.258 322.819C308.979 322.819 351.871 269.548 351.871 204.068C351.871 200.262 354.924 197.174 358.694 197.174C362.463 197.174 365.516 200.259 365.516 204.068C365.515 277.149 316.501 336.606 256.255 336.606Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 401.155,
    y1: 418.889,
    x2: 116.297,
    y2: 86.3548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AEE87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 480.97,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brandIcon.62fda84a3fea88289c5aaa1ad2b0233b.svg";
export { ForwardRef as ReactComponent };